export const PRICE_RANGE: [number, number][] = [
  [59000, 300000],
  [44000, 300000],
];
